import React from "react";
import { DmModal, DmButton } from "dm-react-ui";

import "./timeoutModal.css";
import TimeIcon from "../assets/clock.svg";
import { I18n } from "aws-amplify";

const TimeoutModal = ({ open, countdown, onContinue, onCloseSession }) => {
  return (
    <DmModal
      zIndex={9999999}
      maskStyle={{
        backgroundColor: "rgb(20 3 53 / 60%)",
      }}
      destroyOnClose={true}
      centered={true}
      isModalVisible={open}
      //handleModalCancel={onModalClose}
    >
      <div className="dm-navbar-timeout-modal">
        <div className="dm-navbar-timeout-modal__icon">
          <img src={TimeIcon} alt="Time Icon" />
        </div>
        <div className="dm-navbar-timeout-modal__subtitle">
          <span>
            {I18n.get("For inactivity, we will close your session in ")}
          </span>
        </div>
        <div className="dm-navbar-timeout-modal__countdown">
          <span>
            {countdown || 0}
          </span>
          <span>{I18n.get(" seconds")}</span>
        </div>
        <div className="dm-navbar-timeout-modal__buttons">
          <DmButton type="secondary" onClick={onCloseSession}>
            {I18n.get("Close session")}
          </DmButton>
          <DmButton type="primary" onClick={onContinue}>
            {I18n.get("Continue in Datamart")}
          </DmButton>
        </div>
      </div>
    </DmModal>
  );
};

export default TimeoutModal;
